<template>
  <div class="room-summary">
    <span class="room-summary__title">{{ room.name }}</span>
    <room-info class="room-modal__info" :room="room" />
    <span class="room-summary__show" v-if="amenities.length > 8" v-b-modal="'modal_room_' + room.id">
      Caratteristiche della camera
    </span>
    <ul class="room-summary__amenities" v-if="amenities.length">
      <template v-for="(amenity, amenity_index) in amenities">
        <li
          class="room-summary__amenities-item"
          v-if="amenity_index < 6"
          :key="_uid+'_amenity_'+amenity_index"
        >
          <amenity :item="amenity" :type="'rooms'" />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import Amenity from "@liveeps/components/atoms/amenity"
import RoomInfo from '@liveeps/components/blocks/detail/room/room-info'

export default {
  name: 'room-summary',

  components: {
    'amenity': Amenity,
    'room-info': RoomInfo,
  },

  props: {
    room: Object
  },

  data() {
    return {
    }
  },

  computed: {
    amenities() {
      return Object.values(this.room.amenities || {});
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .room-summary {
    position: sticky;
    top: $grid-gutter-width / 2;
    background-color: $white;
    padding: $grid-gutter-width / 2;
    border-radius: $border-radius-lg * 2;
    margin-right: 8%;

    &__title {
      display: block;
      font-weight: $vb-font-weight-semibold;
      line-height: normal;
      margin-bottom: $grid-gutter-20;
    }

    &__show {
      color: var(--info);
      text-decoration: underline;
      font-size: $font-size-sm;
      cursor: pointer;
      display: inline-block;
      margin-top: $grid-gutter-width / 3;
    }

    &__amenities {
      border-top: 1px solid $gray-200;
      padding: $grid-gutter-width / 5 0 0;
      margin-top: $grid-gutter-width / 3;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &-item {
        list-style: none;
        font-size: $font-size-sm;
        color: $gray-600;
        display: flex;
        align-items: center;
        margin-right: $grid-gutter-width / 4;
        margin-top: $grid-gutter-width / 5;

        &:empty {
          display: none;
        }
      }

      &-icon {
        margin-right: $grid-gutter-width / 6;
      }
    }
  }

</style>